import { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useApolloClient } from '@apollo/client'
import { CourseGroup, HomeBanner } from '../../components'
import { courseFindMany } from '../../graphql'
import { setCourses, setCoursesLoading, useAppDispatch, useAppSelector } from '../../redux'
import { StyledHomeView } from '.'

const HomeView: FC = () => {
  const apollo = useApolloClient()
  const dispatch = useAppDispatch()
  const { user } = useAppSelector((state) => state.user)
  const { courses, loading } = useAppSelector((state) => state.courses)

  const loadCourses = async () => {
    try {
      dispatch(setCoursesLoading(true))

      const { data } = await apollo.query({
        fetchPolicy: 'no-cache',
        query: courseFindMany,
        variables: { hideInactive: true }
      })

      const result = data?.courseFindMany?.docs

      if (!result) {
        return
      }

      dispatch(setCourses(result))
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(setCoursesLoading(false))
    }
  }

  useEffect(() => {
    loadCourses()
  }, [user])

  return (
    <>
      <Helmet title="Social Curator Academy" />
      <StyledHomeView>
        <HomeBanner />
        <div className="page-content">
          <CourseGroup
            label="My courses"
            courses={courses.filter((c) => !!c.isOwned)}
            loading={loading}
          />
          <CourseGroup
            label="Available courses"
            courses={courses.filter((c) => !c.isOwned)}
            loading={loading}
          />
        </div>
      </StyledHomeView>
    </>
  )
}

export default HomeView
